import { ModulPrAuspFilter } from "../ws/modul/modul-pr-ausp-filter.model";

 
export class FilterAuspRow {

    modulPrAuspFilterLinks!: ModulPrAuspFilter;
    modulPrAuspFilterRechts!: ModulPrAuspFilter;

}
 

   